import { PageHeader } from '@/components/shared';
import { useBackofficePageTitle } from '@/lib/page-title';
import { ProjectsListSection } from './components';

export function BackofficeProjectsPage() {
  useBackofficePageTitle('Studies');

  return (
    <main className="min-h-[320px] bg-white p-6 md:p-8" aria-label="Backoffice main content">
      <div className="flex flex-col gap-5">
        <PageHeader>Studies</PageHeader>

        <ProjectsListSection />
      </div>
    </main>
  );
}
